import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron_right_reverse",
  "use": "chevron_right_reverse-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" id=\"chevron_right_reverse\"><path fill=\"none\" stroke=\"#FFF\" stroke-linejoin=\"round\" d=\"M25.428 23.5L29 20l-3.572-3.5M29 20H11\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol